import { colors } from "theme/light.colors";
import createTheme from "./common.theme";

const lightTheme = createTheme("light", colors);

export default lightTheme;